import EditTagModal from 'components/modal/editTagModal';
import React from 'react';
import { useAppDispatch } from 'store/hooks';
import { setGlobalModal } from 'store/transitionSlice';
import { Tag } from 'store/types';

export const useEditHandler = () => {
  const dispatch = useAppDispatch();

  return ({ contextItem }: { contextItem: Tag }) => {
    dispatch(
      setGlobalModal(
        <EditTagModal
          onCancel={() => {
            dispatch(setGlobalModal(null));
          }}
          tag={contextItem}
        ></EditTagModal>
      )
    );
  };
};
